export default function hasTier({ tier } = {}, tierType = '') {
    return (typeof tier === 'string') && tierType !== '' && tier.trim().toLowerCase() === tierType;
}


// WEBPACK FOOTER //
// ./app/lib/util/hasTier.js